import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {CreateAlarmCenter} from 'src/services/api/endpoints/AlarmCenterEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useCreateAlarmCenter() {
  const {enqueueSnackbar} = useSnackbar()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [QueryKeyEnum.CREATE_ALARM_CENTER],
    mutationFn: async (body: CreateAlarmCenter) => {
      return (await api.alarmCenter.createOne(body)).data.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [QueryKeyEnum.ALARM_CENTERS]})
      enqueueSnackbar('Central de alarme criada com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos criar a central de alarme no momento')
    },
  })
}
